import type OrganizationCheckRequestModel from 'ab-requestModels/organizationCheck.requestModel';

import { isValidTextInput } from '@acceligentllc/shared/utils/text';

export default function validate(values: OrganizationCheckRequestModel) {

	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.alias)) {
		errors.alias = 'Alias is required';
	}

	return errors;
}
